import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgChartIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    width="1em"
    height="1em"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g className="chart_svg__nc-icon-wrapper">
      <path d="M44.949 33C44.435 39.701 38.831 45 32 45c-3.395 0-6.479-1.318-8.797-3.457L9.988 53.803C15.609 59.478 23.4 63 32 63c16.758 0 30.444-13.369 30.975-30H44.949z" />
      <path
        data-color="color-2"
        d="M33 19.051c6.37.488 11.461 5.579 11.949 11.949h18.025C62.454 14.702 49.299 1.546 33 1.025v18.026z"
      />
      <path d="M21.837 40.084A12.928 12.928 0 0 1 19 32c0-6.831 5.299-12.435 12-12.949V1.025C14.368 1.556 1 15.242 1 32c0 7.776 2.885 14.887 7.631 20.335l13.206-12.251z" />
    </g>
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgChartStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgChartIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const ChartIcon: any = SvgChartStyle;
export default ChartIcon;
